import React from 'react'
import Accordion from './Accordion';
import StrengthBar from '../../displaycomponents/StrengthBar';

import {loshuTags} from '../../../InfoFiles/DealWItthPeople'
import './numerologyReport.css';

const strength =  ['Weak','Average','Strong','Excessive','Extreme'];

function Header ({data,index}){
    return(
        <div className='loshu-card-header'>
            <span className='plane-name b'>{loshuTags[index+1].field}</span>
                <div className='loshu-gauge-chart'>
                    <StrengthBar max={4} value={(Number(data>4)?4:Number(data))} colorGradient={['#fcf805','lime','#d60202','#590000']}/>
                    <span>{strength[(Number(data>4)?4:Number(data))]}</span>
                </div>
        </div>
    );
}

function Body ({data,index}){
    return(
        <ul>
            {
                Number(data)>0?
                <div>
                {
                    loshuTags[index+1][(Number(data>5)?'5':data)].map(t => <li>{t}</li>)
                }
                </div>
                :
                <div>
                {
                    loshuTags[index+1].missing.map(t => <li>{t}</li>)
                }
                </div>
            }
        </ul>
    )
}

function LoshuReport ({loshuGrid}){
    return(
        <div className='loshu-card-container'>
        {
            loshuGrid.map((data,index) => <Accordion key={index}><Header data={data} index={index}/><Body data={data} index={index}/></Accordion>)
        }
        </div>
    );
}

export default LoshuReport;
